import { useState } from "react";
import { Dropdown, Badge } from "react-bootstrap";
import { useSelector } from "react-redux";
import EmployeesService from "../../../../../../services/HRM/EmployeesService";
import { Translate } from "../../../../../Enums/Tranlate";

const CardItem = ({
	item,
	index,
	setShouldUpdate,
}) => {
	const [restoring, setRestoring] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const employeesService = new EmployeesService();

	return (
		<tr key={index} className="text-center">
			<td>
				<strong>{item.id}</strong>
			</td>
			<td>{item?.name}</td>
			<td>{item.personalEmail}</td>
			<td>{item.companyEmail}</td>
			<td
				style={{
					display: "grid",
					gridTemplateColumns: "auto auto",
					gap: "8px",
				}}>
				{item?.branches?.map((res) => (
					<Badge variant="primary">{res?.names[lang]}</Badge>
				)) || "-"}
			</td>
			<td>{item.department?.name || "-"}</td>
			<td>{item.designation?.title || "-"}</td>
			<td>
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-v" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item
							disabled={restoring}
							onClick={() => {
								setRestoring(true);
								employeesService
									.restore(item.id)
									.then((res) => {
										if (res?.status === 200)
											setShouldUpdate((prev) => !prev);
									})
									.finally(() => setRestoring(false));
							}}>
							{Translate[lang]?.restore}
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</td>
		</tr>
	);
};
export default CardItem;
